"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.listBuildDesignObjectsOutputDtoSchema = exports.buildDesignObjectSchema = exports.listBuildDesignObjectsInputDtoSchema = exports.designObjectTypeSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const query_builder_helpers_js_1 = require("./query-builder-helpers.js");
exports.designObjectTypeSchema = z.enum(['net', 'module', 'component', 'netconn', 'custom']);
exports.listBuildDesignObjectsInputDtoSchema = z.object({
    buildId: z.string(),
    limit: z.number().min(1).max(1000).optional(),
    cursor: z.string().optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.RequirementsV2.buildDesignObjectFilterSchema).optional(),
    columnFilterLogicOperator: query_builder_helpers_js_1.columnFilterLogicOperatorSchema.optional(),
    sort: cadstrom_shared_1.QueryBuilder.createSortZodSchema(cadstrom_shared_1.RequirementsV2.buildDesignObjectFilterSchema).optional(),
});
exports.buildDesignObjectSchema = z.object({
    id: z.string(),
    buildId: z.string(),
    type: exports.designObjectTypeSchema,
    net: z.string().nullable(),
    module: z.string().nullable(),
    component: z.string().nullable(),
    signal: z.string().nullable(),
    customTypeName: z.string().nullable(),
    subjectName: z.string().nullable(),
});
exports.listBuildDesignObjectsOutputDtoSchema = z.object({
    results: exports.buildDesignObjectSchema.array(),
    hasNextPage: z.boolean(),
    nextCursor: z.string().nullable(),
});
//# sourceMappingURL=list-build-design-objects.dto.js.map